/*!
 * DevChef v1.0.0
 * Runtime Telemetry Widget
 * IIFE — keine Dependencies, kein Build-Step nötig
 */
(function (global) {
  'use strict';

  if (global.DevChef && !global.DevChef._stub) return; // bereits geladen

  // ── Config ──────────────────────────────────────────────────────────
  var scriptEl = document.currentScript || (function () {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1];
  })();

  function attr(name, fallback) {
    var val = scriptEl && scriptEl.getAttribute('data-' + name);
    return val !== null ? val : fallback;
  }

  var userConf = global.__devchef_config || {};

  var config = {
    projectId:     userConf.projectId     || attr('project', 'default'),
    endpoint:      userConf.endpoint      || attr('endpoint', null),
    // showPanel: 'auto' = nur wenn /auth/me Operator-Session liefert (default).
    //           'true'  = immer (legacy / Dev-Mode)
    //           'false' = nie (z.B. für Live-Production wenn ganz sicher)
    showPanel:     userConf.showPanel     !== undefined ? userConf.showPanel : attr('panel', 'auto'),
    maxEntries:    parseInt(userConf.maxEntries || attr('max', '500'), 10) || 500,
    feedback:         userConf.feedback         !== undefined ? userConf.feedback : (attr('feedback', 'false') === 'true'),
    // feedbackAuth: 'auto' = Feedback nur für authentifizierte Operatoren (default)
    //               'true' = Feedback für alle (legacy / öffentliche Seiten mit eigenem Auth)
    //               'false' = Feedback deaktiviert
    feedbackAuth:     userConf.feedbackAuth     !== undefined ? userConf.feedbackAuth : attr('feedback-auth', 'auto'),
    flushInterval:    parseInt(userConf.flushInterval || attr('flush-interval', '5000'), 10) || 5000,
    elementSelector:  userConf.elementSelector  || attr('element-selector', null),
    apiKey:           userConf.apiKey           || attr('api-key', null),
    // User-Info für Feedback-Attribution (aus Odoo, CMS, etc.)
    userName:         userConf.userName         || attr('user-name', null),
    userEmail:        userConf.userEmail        || attr('user-email', null),
    // Long-Task-Warnungen erst ab dieser Dauer (ms). Browser meldt ab 50ms;
    // knapp darüber (z.B. 60–70ms) erzeugt sonst viel Autopilot-Rauschen.
    longTaskMinMs:    (function () {
      var raw = userConf.longTaskMinMs !== undefined ? String(userConf.longTaskMinMs) : attr('long-task-min-ms', '50');
      var n = parseInt(raw, 10);
      return isNaN(n) ? 50 : Math.max(0, n);
    })(),
  };

  // ── Session ─────────────────────────────────────────────────────────
  var session = {
    id:        Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10),
    started:   new Date().toISOString(),
    projectId: config.projectId,
    url:       location.href,
    ua:        navigator.userAgent,
    viewport:  { w: global.innerWidth, h: global.innerHeight },
  };

  // ── Ring-Buffer ──────────────────────────────────────────────────────
  var _entries = [];
  var _subscribers = new Set();

  function add(source, level, message, meta) {
    var entry = {
      ts:      new Date().toISOString(),
      source:  source,
      level:   level,
      message: String(message).slice(0, 2000),
      meta:    meta || null,
    };
    _entries.push(entry);
    if (_entries.length > config.maxEntries) {
      _entries = _entries.slice(-config.maxEntries);
    }
    _subscribers.forEach(function (fn) {
      try { fn(entry, _entries); } catch (_) {}
    });
    _panel_push(entry);
    return entry;
  }

  function serialize(val) {
    if (val === null || val === undefined) return String(val);
    if (typeof val === 'string') return val;
    if (typeof val === 'number' || typeof val === 'boolean') return String(val);
    try { return JSON.stringify(val); } catch (_) { return '[object]'; }
  }

  // ── Originals speichern ──────────────────────────────────────────────
  var _orig = {
    consoleLog:   console.log.bind(console),
    consoleWarn:  console.warn.bind(console),
    consoleError: console.error.bind(console),
    consoleInfo:  console.info.bind(console),
    consoleDebug: console.debug.bind(console),
    fetch:        global.fetch ? global.fetch.bind(global) : null,
    xhrOpen:      XMLHttpRequest.prototype.open,
    xhrSend:      XMLHttpRequest.prototype.send,
    onerror:      global.onerror || null,
    onunhandledrejection: global.onunhandledrejection || null,
  };

  function isOwnEndpoint(url) {
    if (!config.endpoint) return false;
    try {
      var u = typeof url === 'string' ? url : (url && (url.url || url.href)) || '';
      if (!u) return false;
      var epResolved = new URL(config.endpoint, location.href);
      var target     = new URL(u, location.href);
      return target.origin === epResolved.origin && target.pathname.indexOf(epResolved.pathname) === 0;
    } catch (_) { return false; }
  }

  // ── Console Hooks ────────────────────────────────────────────────────
  function hookConsole(method, level) {
    console[method] = function () {
      _orig['console' + method.charAt(0).toUpperCase() + method.slice(1)].apply(console, arguments);
      var parts = [];
      for (var i = 0; i < arguments.length; i++) parts.push(serialize(arguments[i]));
      add('console', level === 'debug' ? 'info' : level, parts.join(' '));
    };
  }
  hookConsole('log',   'log');
  hookConsole('warn',  'warn');
  hookConsole('error', 'error');
  hookConsole('info',  'info');
  hookConsole('debug', 'debug');

  // ── window.onerror ───────────────────────────────────────────────────
  global.onerror = function (msg, src, line, col, err) {
    add('error', 'error', String(msg), {
      source: src || null,
      line:   line || null,
      col:    col  || null,
      stack:  err && err.stack ? err.stack.split('\n').slice(0, 6).join('\n') : null,
    });
    if (_orig.onerror) return _orig.onerror.apply(global, arguments);
    return false;
  };

  // ── unhandledrejection ───────────────────────────────────────────────
  global.onunhandledrejection = function (ev) {
    var reason = ev.reason;
    add('error', 'error', 'Unhandled Promise: ' + serialize(reason), {
      stack: reason && reason.stack ? reason.stack.split('\n').slice(0, 6).join('\n') : null,
    });
    if (_orig.onunhandledrejection) _orig.onunhandledrejection.call(global, ev);
  };

  // ── fetch Hook ───────────────────────────────────────────────────────
  if (global.fetch) {
    global.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '?';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (isOwnEndpoint(url)) return _orig.fetch(input, init);
      var t0 = performance.now();
      return _orig.fetch(input, init).then(
        function (res) {
          add('network', res.ok ? 'info' : 'warn', method.toUpperCase() + ' ' + url, {
            status:   res.status,
            duration: Math.round(performance.now() - t0) + 'ms',
            size:     res.headers.get('content-length') || null,
          });
          return res;
        },
        function (err) {
          add('network', 'error', method.toUpperCase() + ' ' + url + ' FAILED', {
            error:    err.message,
            duration: Math.round(performance.now() - t0) + 'ms',
          });
          throw err;
        }
      );
    };
  }

  // ── XHR Hook ────────────────────────────────────────────────────────
  XMLHttpRequest.prototype.open = function (method, url) {
    this._dc_info = { method: method, url: url };
    return _orig.xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var self = this;
    var info = self._dc_info || {};
    if (!isOwnEndpoint(info.url)) {
      var t0 = performance.now();
      self.addEventListener('loadend', function () {
        var level = self.status >= 200 && self.status < 400 ? 'info' : 'warn';
        if (self.status === 0) level = 'error';
        add('network', level, (info.method || 'GET') + ' ' + info.url, {
          status:   self.status,
          duration: Math.round(performance.now() - t0) + 'ms',
        });
      }, { once: true });
    }
    return _orig.xhrSend.apply(self, arguments);
  };

  // ── PerformanceObserver ──────────────────────────────────────────────
  if (global.PerformanceObserver) {
    try {
      var perfObs = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.entryType === 'longtask') {
            if (entry.duration < config.longTaskMinMs) {
              return;
            }
            add('perf', 'warn', 'Long Task: ' + Math.round(entry.duration) + 'ms', {
              duration:   Math.round(entry.duration),
              startTime:  Math.round(entry.startTime),
            });
          } else if (entry.entryType === 'largest-contentful-paint') {
            add('perf', 'info', 'LCP: ' + Math.round(entry.startTime) + 'ms', {
              element: entry.element ? entry.element.tagName : null,
              size:    Math.round(entry.size),
            });
          } else if (entry.entryType === 'layout-shift') {
            if (entry.value > 0.05) {
              add('perf', 'warn', 'Layout Shift: ' + entry.value.toFixed(4), {
                value:    entry.value,
                hadInput: entry.hadRecentInput,
              });
            }
          }
        });
      });
      perfObs.observe({ entryTypes: ['longtask', 'largest-contentful-paint', 'layout-shift'] });
    } catch (_) {}
  }

  // ── Lifecycle ────────────────────────────────────────────────────────
  document.addEventListener('visibilitychange', function () {
    add('system', 'info', 'visibility:' + document.visibilityState);
    if (document.visibilityState === 'hidden') _flush(true);
  });

  global.addEventListener('beforeunload', function () {
    add('system', 'info', 'beforeunload');
    _flush(true);
  });

  // ── Flush ────────────────────────────────────────────────────────────
  var _lastFlushIdx = 0;
  var _flushTimer = null;

  function _flush(useBeacon) {
    if (!config.endpoint) return;
    var toSend = _entries.slice(_lastFlushIdx);
    if (toSend.length === 0) return;
    _lastFlushIdx = _entries.length;

    var payload = JSON.stringify({ session: session, entries: toSend });

    var headers = { 'Content-Type': 'application/json' };
    if (config.apiKey) headers['Authorization'] = 'Bearer ' + config.apiKey;

    // Key immer auch als Query-Param (sendBeacon hat keine Header, fetch kann durch Frameworks gepatcht werden)
    var url = config.apiKey ? config.endpoint + (config.endpoint.indexOf('?') < 0 ? '?' : '&') + 'key=' + encodeURIComponent(config.apiKey) : config.endpoint;

    if (useBeacon && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    } else {
      try {
        _orig.fetch(url, {
          method:  'POST',
          headers: headers,
          body:    payload,
          keepalive: useBeacon,
        });
      } catch (_) {}
    }
  }

  function _startFlushTimer() {
    if (_flushTimer) clearInterval(_flushTimer);
    _flushTimer = setInterval(function () { _flush(false); }, config.flushInterval);
  }

  if (config.endpoint) _startFlushTimer();

  // ── Floating Panel ───────────────────────────────────────────────────
  var _panelOpen = false;
  var _panelFilter = 'ALL';
  var _panelEntries = [];
  var _panelEl = null;
  var _panelListEl = null;
  var _fabEl = null;
  var _errorCount = 0;

  var PANEL_CSS = [
    '#dc-fab{position:fixed;bottom:16px;right:16px;width:44px;height:44px;border-radius:10px',
    ';background:linear-gradient(135deg,#ff6b00,#ff9500);border:none;cursor:pointer;z-index:2147483646',
    ';font-size:18px;font-weight:900;color:#000;box-shadow:0 4px 20px rgba(255,107,0,.35)',
    ';display:flex;align-items:center;justify-content:center;font-family:sans-serif}',
    '#dc-fab:hover{transform:scale(1.05)}',
    '#dc-badge{position:absolute;top:-4px;right:-4px;background:#ff3b30;color:#fff;font-size:9px',
    ';font-weight:700;min-width:16px;height:16px;border-radius:8px;display:none',
    ';align-items:center;justify-content:center;padding:0 3px;font-family:monospace}',
    '#dc-panel{position:fixed;bottom:68px;right:16px;width:420px;max-height:520px',
    ';background:#0e0e12;border:1px solid #222;border-radius:12px;z-index:2147483645',
    ';display:none;flex-direction:column;font-family:"SF Mono",monospace;font-size:11px',
    ';box-shadow:0 8px 40px rgba(0,0,0,.7)}',
    '#dc-panel.open{display:flex}',
    '#dc-head{padding:10px 12px;border-bottom:1px solid #1a1a1e;display:flex;align-items:center;gap:8px;flex-shrink:0}',
    '#dc-head .dc-title{color:#ff9500;font-weight:700;letter-spacing:1px;font-size:11px}',
    '#dc-head .dc-proj{color:#444;font-size:10px;margin-left:4px}',
    '#dc-head .dc-close{margin-left:auto;cursor:pointer;color:#444;font-size:14px;padding:2px 6px;border-radius:4px}',
    '#dc-head .dc-close:hover{color:#ccc;background:#1a1a1e}',
    '#dc-filters{padding:6px 12px;border-bottom:1px solid #1a1a1e;display:flex;gap:6px;flex-shrink:0}',
    '.dc-filter{font-family:inherit;font-size:10px;padding:3px 10px;border-radius:4px',
    ';border:1px solid #222;background:#111;color:#555;cursor:pointer;letter-spacing:.5px}',
    '.dc-filter.active{border-color:#ff9500;color:#ff9500;background:#1a1200}',
    '.dc-filter:hover:not(.active){border-color:#333;color:#888}',
    '#dc-list{flex:1;overflow-y:auto;padding:4px 0;min-height:0}',
    '.dc-entry{padding:3px 12px;display:flex;gap:8px;border-bottom:1px solid #0a0a0d;line-height:1.5}',
    '.dc-entry:last-child{border-bottom:none}',
    '.dc-ts{color:#222;font-size:9px;min-width:68px;flex-shrink:0}',
    '.dc-src{width:14px;text-align:center;flex-shrink:0}',
    '.dc-msg{word-break:break-all;color:#666}',
    '.dc-entry.error .dc-src{color:#ff3b30}.dc-entry.error .dc-msg{color:#ff6b6b}',
    '.dc-entry.warn .dc-src{color:#ff9500}.dc-entry.warn .dc-msg{color:#e8a000}',
    '.dc-entry.info .dc-src{color:#30d158}.dc-entry.info .dc-msg{color:#888}',
    '.dc-entry.log .dc-src{color:#555}.dc-entry.log .dc-msg{color:#777}',
    '#dc-actions{padding:8px 12px;border-top:1px solid #1a1a1e;display:flex;gap:6px;flex-shrink:0}',
    '.dc-btn{font-family:inherit;font-size:10px;padding:4px 10px;border-radius:4px',
    ';border:1px solid #222;background:#111;color:#888;cursor:pointer}',
    '.dc-btn:hover{border-color:#ff9500;color:#ff9500}',
    // ── Mobile Responsive ──
    '@media(max-width:480px){',
    '#dc-fab{bottom:12px;right:12px;width:40px;height:40px;font-size:16px}',
    '#dc-panel{width:calc(100vw - 24px);right:12px;bottom:60px;max-height:60vh}',
    '}',
  ].join('');

  var SICO = { console: '›', error: '✕', network: '⇄', perf: '◎', system: '⚙', feedback: '💬' };

  function _esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function _buildPanel() {
    // Style
    var style = document.createElement('style');
    style.id = 'dc-style';
    style.textContent = PANEL_CSS;
    document.head.appendChild(style);

    // FAB
    _fabEl = document.createElement('button');
    _fabEl.id = 'dc-fab';
    _fabEl.innerHTML = '◆<span id="dc-badge"></span>';
    _fabEl.title = 'DevChef';
    _fabEl.addEventListener('click', function () { _togglePanel(); });
    document.body.appendChild(_fabEl);

    // Panel
    _panelEl = document.createElement('div');
    _panelEl.id = 'dc-panel';
    _panelEl.innerHTML = [
      '<div id="dc-head">',
      '  <span class="dc-title">DEVCHEF</span>',
      '  <span class="dc-proj">' + _esc(config.projectId) + '</span>',
      '  <span class="dc-close" onclick="document.getElementById(\'dc-panel\').classList.remove(\'open\')" title="Close">✕</span>',
      '</div>',
      '<div id="dc-filters">',
      '  <button class="dc-filter active" data-f="ALL">ALL</button>',
      '  <button class="dc-filter" data-f="console">CON</button>',
      '  <button class="dc-filter" data-f="error">ERR</button>',
      '  <button class="dc-filter" data-f="network">NET</button>',
      '  <button class="dc-filter" data-f="perf">PERF</button>',
      '</div>',
      '<div id="dc-list"></div>',
      '<div id="dc-actions">',
      '  <button class="dc-btn" id="dc-copy">Copy JSON</button>',
      '  <button class="dc-btn" id="dc-dl">Download</button>',
      '  <button class="dc-btn" id="dc-clr">Clear</button>',
      '</div>',
    ].join('');
    document.body.appendChild(_panelEl);

    _panelListEl = document.getElementById('dc-list');

    // Filter clicks
    _panelEl.querySelectorAll('.dc-filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        _panelFilter = btn.getAttribute('data-f');
        _panelEl.querySelectorAll('.dc-filter').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        _panelRender();
      });
    });

    // Actions
    document.getElementById('dc-copy').addEventListener('click', function () {
      try { navigator.clipboard.writeText(global.DevChef.exportJSON()); } catch (_) {}
    });
    document.getElementById('dc-dl').addEventListener('click', function () {
      var blob = new Blob([global.DevChef.exportJSON()], { type: 'application/json' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'devchef-' + config.projectId + '-' + Date.now() + '.json';
      a.click();
    });
    document.getElementById('dc-clr').addEventListener('click', function () { global.DevChef.clear(); });
  }

  function _panelRender() {
    if (!_panelListEl) return;
    var filtered = _panelEntries.filter(function (e) {
      if (_panelFilter === 'ALL') return true;
      if (_panelFilter === 'error') return e.source === 'error' || e.level === 'error';
      return e.source === _panelFilter;
    });
    var last100 = filtered.slice(-100);
    _panelListEl.innerHTML = last100.map(function (e) {
      var ts = e.ts ? e.ts.split('T')[1].slice(0, 12) : '';
      var msg = e.message.length > 120 ? e.message.slice(0, 120) + '…' : e.message;
      var cls = e.level === 'error' ? 'error' : e.level === 'warn' ? 'warn' : e.source === 'feedback' ? 'info' : e.level === 'info' ? 'info' : 'log';
      return '<div class="dc-entry ' + cls + '">' +
        '<span class="dc-ts">' + _esc(ts) + '</span>' +
        '<span class="dc-src">' + _esc(SICO[e.source] || '·') + '</span>' +
        '<span class="dc-msg">' + _esc(msg) + '</span>' +
        '</div>';
    }).join('');
    _panelListEl.scrollTop = _panelListEl.scrollHeight;
  }

  function _panel_push(entry) {
    _panelEntries.push(entry);
    if (_panelEntries.length > 500) _panelEntries = _panelEntries.slice(-500);

    if (entry.level === 'error' || entry.source === 'error') {
      _errorCount++;
      var badge = document.getElementById('dc-badge');
      if (badge) {
        badge.style.display = 'flex';
        badge.textContent = _errorCount > 99 ? '99+' : String(_errorCount);
      }
    }

    if (_panelOpen) _panelRender();
  }

  function _togglePanel() {
    _panelOpen = !_panelOpen;
    if (_panelEl) _panelEl.classList.toggle('open', _panelOpen);
    if (_panelOpen) {
      _errorCount = 0;
      var badge = document.getElementById('dc-badge');
      if (badge) badge.style.display = 'none';
      _panelRender();
    }
  }

  // ── Operator-Detection (Authentik-Session via Bridge /auth/me) ───────
  // Cross-origin fetch mit credentials. Cookie wurde von der Bridge mit
  // samesite=none gesetzt, kommt also auf wildfind.com etc. mit. Wenn der
  // User in Authentik eingeloggt ist (= Operator), zeigen wir das Dev-Panel.
  // showPanel='auto' (default) → Panel wird erst nach erfolgreicher Detection
  //                              gebaut, default-hidden für Kunden
  // showPanel='true'           → immer bauen (legacy / dev mode)
  // showPanel='false'          → nie
  var _operator = null;  // {username, role, projects} oder null
  function _detectOperator() {
    if (!config.endpoint) return Promise.resolve(null);
    // Bridge-Base aus dem ingest endpoint ableiten: alles vor /ingest oder /api
    var base = config.endpoint.replace(/\/(ingest|api).*$/, '').replace(/\/$/, '');
    if (!base) return Promise.resolve(null);
    return fetch(base + '/auth/me', { credentials: 'include' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        _operator = data || null;
        if (global.DevChef) global.DevChef.user = _operator;
        return _operator;
      })
      .catch(function () { return null; });
  }

  function _maybeBuildPanel() {
    var force = config.showPanel === 'true' || config.showPanel === true;
    var auto  = config.showPanel === 'auto';
    var off   = config.showPanel === 'false' || config.showPanel === false;
    if (off) return;
    if (force) {
      _buildPanel();
      return;
    }
    if (auto) {
      _detectOperator().then(function (user) {
        if (user) _buildPanel();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _maybeBuildPanel);
  } else {
    _maybeBuildPanel();
  }

  // ── Feedback Addon ────────────────────────────────────────────────────
  function _loadFeedback() {
    if (global._DevChefFeedbackLoaded) return;
    // devchef-feedback.js via Script-Tag laden (gleicher Pfad wie devchef.js)
    var base = '', query = '';
    if (scriptEl && scriptEl.src) {
      base = scriptEl.src.replace(/devchef(\.min)?\.js([^/]*)$/, '');
      // Versions-Query (z. B. ?v=18.0.2.3.5) an das Addon weiterreichen: neue Version = neue Adresse,
      // sonst hält der Browser das alte devchef-feedback.js bis zu einer Woche (Cache-Control max-age) (30.10.2026)
      var m = scriptEl.src.match(/devchef(?:\.min)?\.js(\?[^/#]*)?(?:#.*)?$/);
      query = (m && m[1]) || '';
    }
    var s = document.createElement('script');
    s.src = base + 'devchef-feedback.js' + query;
    s.onerror = function () {
      _orig.consoleWarn('[DevChef] devchef-feedback.js nicht gefunden');
    };
    document.head.appendChild(s);
  }

  // ── stop() — Hooks restoren ──────────────────────────────────────────
  function stop() {
    console.log   = _orig.consoleLog;
    console.warn  = _orig.consoleWarn;
    console.error = _orig.consoleError;
    console.info  = _orig.consoleInfo;
    console.debug = _orig.consoleDebug;
    if (_orig.fetch) global.fetch = _orig.fetch;
    XMLHttpRequest.prototype.open = _orig.xhrOpen;
    XMLHttpRequest.prototype.send = _orig.xhrSend;
    global.onerror = _orig.onerror;
    global.onunhandledrejection = _orig.onunhandledrejection;
    if (_flushTimer) { clearInterval(_flushTimer); _flushTimer = null; }
    _flush(false);
  }

  // ── Public API ───────────────────────────────────────────────────────
  global.DevChef = {
    _stub: false,
    session: session,
    config:  config,

    entries: function () { return _entries.slice(); },

    stats: function () {
      var bySource = {}, byLevel = {};
      _entries.forEach(function (e) {
        bySource[e.source] = (bySource[e.source] || 0) + 1;
        byLevel[e.level]   = (byLevel[e.level]   || 0) + 1;
      });
      return { total: _entries.length, bySource: bySource, byLevel: byLevel };
    },

    export: function () {
      return { _devchef: '1.0', session: session, entries: _entries.slice(), stats: global.DevChef.stats() };
    },

    exportJSON: function () {
      return JSON.stringify(global.DevChef.export(), null, 2);
    },

    clear: function () {
      _entries = [];
      _panelEntries = [];
      _lastFlushIdx = 0;
      _errorCount = 0;
      var badge = document.getElementById('dc-badge');
      if (badge) badge.style.display = 'none';
      if (_panelListEl) _panelListEl.innerHTML = '';
    },

    log:   function (msg, meta) { return add('console', 'log',   msg, meta); },
    warn:  function (msg, meta) { return add('console', 'warn',  msg, meta); },
    error: function (msg, meta) { return add('console', 'error', msg, meta); },
    mark:  function (label, meta) { return add('system', 'info', 'MARK: ' + label, meta); },

    add: add,

    subscribe: function (fn) {
      _subscribers.add(fn);
      return function () { _subscribers.delete(fn); };
    },

    toggle: function () { _togglePanel(); },

    enableFeedback: function () { _loadFeedback(); },

    flush: function () { _flush(false); },

    startFlushTimer: function () { _startFlushTimer(); },

    stop: stop,

    // Operator-Info nach Auth-Detection. Null wenn Customer / nicht eingeloggt.
    user: null,

    // Manuell den Operator-Status nochmal probieren (z.B. nach OIDC-Login in
    // einem anderen Tab) — baut Panel sofern erfolgreich.
    refreshAuth: function () {
      return _detectOperator().then(function (u) {
        if (u && !_panelEl) _buildPanel();
        return u;
      });
    },
  };

  // System-Entry: Widget geladen
  add('system', 'info', 'DevChef v1.0.0 loaded', {
    project:  config.projectId,
    endpoint: config.endpoint || null,
    panel:    config.showPanel,
    feedback: config.feedback,
    feedbackAuth: config.feedbackAuth,
  });

  // Feedback laden — abhängig von feedbackAuth-Einstellung
  function _isOdooLoggedIn() {
    try {
      // Odoo 18+: csrf_token existiert nur für authentifizierte User
      if (global.odoo && global.odoo.csrf_token) return true;
      // Odoo 13-17 Legacy: session_info.uid
      return global.odoo && global.odoo.session_info && global.odoo.session_info.uid > 0;
    } catch (_) { return false; }
  }
  var _feedbackLoaded = false;
  function _maybeLoadFeedback(retryCount) {
    if (_feedbackLoaded) return;
    if (!config.feedback) return;
    var authMode = config.feedbackAuth;
    if (authMode === 'false' || authMode === false) return;
    if (authMode === 'true' || authMode === true) {
      _feedbackLoaded = true;
      _loadFeedback();
      return;
    }
    // 'auto' (default): für authentifizierte Operatoren ODER Odoo-User
    // Odoo-Check ist synchron — wenn eingeloggt, sofort laden
    if (_isOdooLoggedIn()) {
      _feedbackLoaded = true;
      _loadFeedback();
      return;
    }
    // Odoo 18+: window.odoo existiert aber csrf_token kommt verzögert
    // Retry mit Backoff für bis zu 2 Sekunden
    retryCount = retryCount || 0;
    if (global.odoo && retryCount < 4) {
      setTimeout(function() { _maybeLoadFeedback(retryCount + 1); }, 500);
      // Parallel auch Authentik prüfen (non-blocking)
      if (retryCount === 0 && !_operator) {
        _detectOperator().then(function () {
          if (_operator && !_feedbackLoaded) {
            _feedbackLoaded = true;
            _loadFeedback();
          }
        });
      }
      return;
    }
    // Fallback: Authentik-Check wenn kein Odoo
    if (_operator) {
      _feedbackLoaded = true;
      _loadFeedback();
    } else if (!global.odoo) {
      _detectOperator().then(function () {
        if (_operator && !_feedbackLoaded) {
          _feedbackLoaded = true;
          _loadFeedback();
        }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _maybeLoadFeedback);
  } else {
    _maybeLoadFeedback();
  }

}(typeof window !== 'undefined' ? window : this));
